import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PeopleIcon from "@mui/icons-material/People";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ExploreIcon from "@mui/icons-material/Explore";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DescriptionIcon from "@mui/icons-material/Description";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ChatIcon from "@mui/icons-material/Chat";
import {
  Dashboard as DashboardIcon,
  Assignment as RequirementIcon,
  Settings,
} from "@mui/icons-material";
import BarChartIcon from "@mui/icons-material/BarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HistoryIcon from "@mui/icons-material/History";
import GetAppIcon from "@mui/icons-material/GetApp";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
const sidebar = {
  buyer: [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/buyer/dashboard",
    },
    {
      name: "Trade Marketplace",
      icon: <FileCopyIcon />,
      submenu: [
        {
          name: "My Trade Dashboard",
          path: "/buyer/tradedashboard",
          icon: <DashboardIcon />,
        },
        {
          name: "Discover & Evaluate",
          label: "Discover & Evaluate",
          path: "/buyer/discoverevaluate",
          icon: <ExploreIcon />,
        },
        {
          name: "Requirements",
          label: "Requirement",
          path: "/buyer/requirement",
          icon: <RequirementIcon />,
        },
        {
          name: "RFQs & Offers",
          label: "RFQs & Offers",
          path: "/buyer/rfqoffers",
          icon: <RequestQuoteIcon />,
        },
        {
          name: "Orders",
          label: "Orders",
          path: "/buyer/orders",
          icon: <LocalShippingIcon />,
        },
      ],
    },
    {
      name: "Finance Marketplace",
      icon: <EventAvailableIcon />,
      submenu: [
        {
          name: "My Finance Dashboard",
          label: "My Finance Dashboard",
          path: "/buyer/finance/h",
          icon: <RequirementIcon />,
        },
        {
          name: "Discover & Evaluate",
          label: "Discover & Evaluate",
          path: "/buyer/dis",
          icon: <ExploreIcon />,
        },
        {
          name: "RFQs & Offers",
          label: "RFQs & Offers",
          path: "/buyer/finance/rfqoffers",
          icon: <RequestQuoteIcon />,
          submenu: [
            {
              name: "Payment & Financing Instruments",
              path: "/buyer/finance/rfqoffers",
              icon: <ExploreIcon />,
            },
            {
              name: "Working Capital & Liquidity",
              path: "/buyer/offers/working-capital",
              icon: <ExploreIcon />,
            },
            {
              name: "Risk Mitigation Tools",
              path: "/buyer/offers/risk-mitigation",
              icon: <ExploreIcon />,
            },
            {
              name: "FX & Hedging Solutions",
              path: "/buyer/offers/fx-hedging",
              icon: <ExploreIcon />,
            },
          ],
        },
        {
          name: "Apply for Finance",
          label: "My Offers",
          path: "/buyer/ordersn",
          icon: <LocalShippingIcon />,
        },
        {
          name: "Application Tracker",
          label: "My Offers",
          path: "/buyer/ordersns",
          icon: <LocalShippingIcon />,
        },
      ],
    },
    // {
    //     name: 'Payment',
    //     icon: <PaymentIcon />,
    //     link: '/buyer/payment',
    // },
    {
      name: "Documents Vault",
      icon: <FolderOpenIcon />, // Using FolderOpenIcon as a substitute
      submenu: [
        {
          name: "All Documents",
          path: "/buyer/documentvault",
          icon: <DescriptionIcon />,
        },
        // { name: 'KYC Documents', path: '/buyer/kycdocuments', icon: <DescriptionIcon /> },
        // { name: 'Trade Contracts / POs', path: '/buyer/trade-contracts', icon: <AssignmentIcon /> },
        // { name: 'LC / SBLC Documents', path: '/buyer/lc-sblc', icon: <AssignmentIcon /> },
        // { name: 'Invoices', path: '/buyer/invoices', icon: <ReceiptLongIcon /> },
        // { name: 'Shipping / Customs Docs', path: '/buyer/shipping-customs', icon: <LocalShippingIcon /> },
        // { name: 'Upload / Share with Finance Partner', path: '/documents/upload-share', icon: <ShareIcon /> },
      ],
    },
    {
      name: "Shipments & Logistics",
      icon: <LocalShippingIcon />, // Using LocalShippingIcon as a substitute
      submenu: [
        {
          name: "Logistics",
          path: "/buyer/shipments/page",
          icon: <LocalShippingIcon />,
        },
        {
          name: "Track Shipments",
          path: "/buyer/shipments/track",
          icon: <TrackChangesIcon />,
        },
        {
          name: "Partner Logistics Providers",
          path: "/buyer/shipments/partners",
          icon: <PeopleIcon />,
        },
        {
          name: "Documents for Customs / Insurance",
          path: "/buyer/shipments/documents",
          icon: <DescriptionIcon />,
        },
        {
          name: "Delivery Timelines",
          path: "/buyer/shipments/timelines",
          icon: <ScheduleIcon />,
        },
      ],
    },
    {
      name: "Analytics & Finance",
      icon: <BarChartIcon />, // Using BarChartIcon as a substitute
      submenu: [
        {
          name: "Trade Value",
          path: "/buyer/analytics/trade-value",
          icon: <AttachMoneyIcon />,
        },
        {
          name: "Finance Usage",
          path: "/buyer/analytics/finance-usage",
          icon: <AccountBalanceIcon />,
        },
        {
          name: "Repayment Schedule",
          path: "/buyer/analytics/repayment",
          icon: <EventRepeatIcon />,
        },
        {
          name: "Credit Score Insights",
          path: "/buyer/analytics/credit-score",
          icon: <AssessmentIcon />,
        },
        {
          name: "Shipment History",
          path: "/buyer/analytics/shipment-history",
          icon: <HistoryIcon />,
        },
        {
          name: "Export/Download Data",
          path: "/buyer/analytics/export",
          icon: <GetAppIcon />,
        },
      ],
    },
    // {
    //     name: 'Seller Bank Communications',
    //     icon: <ChatIcon />, // Using ChatIcon as a substitute
    //     submenu: [
    //         { name: 'Chat Message Center', path: '/communications/chat', icon: <ForumIcon /> },
    //         { name: 'Negotiation Logs', path: '/communications/negotiation', icon: <RecordVoiceOverIcon /> },
    //         { name: 'Alerts & Notifications', path: '/communications/alerts', icon: <NotificationsIcon /> },

    //     ],
    // },
    {
      name: "Profile",
      icon: <PeopleIcon />,
      link: "/buyer/profile",
    },
    {
      name: "Settings",
      icon: <Settings />,
      link: "/buyer/setting",
    },
    {
      name: "Support",
      icon: <SupportAgentIcon />,
      link: "/buyer/support",
    },
    {
      name: "Messaging",
      icon: <ChatIcon />,
      link: "/buyer/messaging",
    },
    {
      name: "User & Roles",
      icon: <PeopleIcon />,
      link: "/buyer/user-role",
    },
  ],
};

export default sidebar;
